import { createContext, useContext, useState, useMemo } from 'react';

const UIContext = createContext({
  headerHeight: 0,
  headerHeightMobile: 0,
});

export const UIProvider = ({ children, headerHeight, headerHeightMobile }) => {
  const [topicMenuHeight, setTopicMenuHeight] = useState();

  const values = useMemo(
    () => ({
      headerHeight,
      headerHeightMobile,
      topicMenuHeight,
      setTopicMenuHeight,
    }),
    [headerHeight, headerHeightMobile, topicMenuHeight],
  );

  return <UIContext.Provider value={values}>{children}</UIContext.Provider>;
};

export const useUIContext = () => useContext(UIContext);

export const withUIContext = (Component) => (props) => {
  const contextValue = useUIContext();

  return <Component {...contextValue} {...props} />;
};

export default UIContext;
